import { useGetShopMatchingSetQuery } from './getShopMatchingSet';

import mockedResponse from './useShopMatchingSetQuery.mockedResponse';

const useShopMatchingSetQuery = ({ skuId }: { skuId: string }) => {
  const {
    data: shopMatchingSetData,
    loading: shopMatchingSetLoading,
    error: shopMatchingSetError,
  } = useGetShopMatchingSetQuery({
    skip: !skuId,
    variables: {
      skuId,
    },
  });

  /* @ts-ignore no type for window */
  if (window.gon.use_mock_graphql_data) {
    return {
      shopMatchingSetData: mockedResponse.data,
      shopMatchingSetError,
      shopMatchingSetLoading,
    };
  }

  return {
    shopMatchingSetData,
    shopMatchingSetError,
    shopMatchingSetLoading,
  };
};

export default useShopMatchingSetQuery;
